import { createElementBlock as n, openBlock as t, createElementVNode as o } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
};
function l(c, e) {
  return t(), n("svg", r, [...e[0] || (e[0] = [
    o("path", {
      fill: "currentColor",
      d: "M25.333 4H6.667A2.666 2.666 0 0 0 4 6.667v18.666A2.666 2.666 0 0 0 6.667 28h18.666A2.666 2.666 0 0 0 28 25.333V6.667A2.666 2.666 0 0 0 25.333 4M12 22.667H8.636v-9.334H12zm-1.741-11.044c-1.028 0-1.715-.686-1.715-1.6 0-.915.685-1.6 1.828-1.6 1.028 0 1.715.685 1.715 1.6 0 .914-.686 1.6-1.828 1.6M24 22.667h-3.256v-5.102c0-1.41-.868-1.736-1.193-1.736s-1.411.218-1.411 1.736v5.102h-3.364v-9.334h3.364v1.303c.433-.76 1.301-1.303 2.93-1.303 1.627 0 2.93 1.303 2.93 4.232z"
    }, null, -1)
  ])]);
}
const i = { render: l };
export {
  i as default,
  l as render
};
